import apiHelper from "./apiHelper"
import { API_ROUTES } from "../utils/constants"

export function createManagerBot(data) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.CREATE, data })
}

export function editManagerBot(data) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.EDIT, data })
}

export function toggleAutorenew(data) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.TOGGLE_AUTORENEW, data })
}

export function connectManagerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.CONNECT, data: { botId } })
}

export function disconnectManagerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.DISCONNECT, data: { botId } })
}

export function reconnectManagerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.RECONNECT, data: { botId } })
}

export function extendManagerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.EXTEND, data: { botId } })
}

export function deleteManagerBot(botId) {
    return apiHelper({ method: "delete", path: API_ROUTES.MANAGER_BOT.DELETE, data: { botId } })
}

export function activateManagerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.ACTIVATE, data: { botId } })
}

export function suspendManagerBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.SUSPEND, data: { botId } })
}

export function getManagerBotList() {
    return apiHelper({ method: "get", path: API_ROUTES.MANAGER_BOT.GET_LIST })
}

export function startAllManagerBots(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.CONNECT_BULK, data: { selecteds } })
}

export function stopAllManagerBots(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.DISCONNECT_BULK, data: { selecteds } })
}

export function restartAllManagerBots(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.RECONNECT_BULK, data: { selecteds } })
}

export function fetchConnecitonData(data) {
    return apiHelper({ method: "post", path: API_ROUTES.MANAGER_BOT.FETCH_CONNECTION_DATA, data })
}
